import BasketballGround from '../../components/Sports/Courts/BasketballCourt/Court'
import FootballGround from '../../components/Sports/Courts/FootballCourt/Court'
// court Images
import purcell_pavilion_arena from '../../assets/images/purcell_pavilion_arena.png';
import stegeman_coliseum_arena from '../../assets/images/stegeman_coliseum_arena.png';
// ball Images
import basketballImage from '../../assets/svgs/basketball.svg';
import footballImage from '../../assets/svgs/american-football.svg';

export const COMMENTARY_POSITION = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary"
}

export const COURT_SEASON_CODES = {
    BASKETBALL: "FIGHT-SES",
    NBA_BASKETBALL: "PRO-BSKT",
    FOOTBALL: "TKN-FB"
}

export const getSportCourtFields = ({ COURT_SEASON_CODES, COURT_CODE }) => {
    if(!COURT_SEASON_CODES || !COURT_CODE) return;
    
    switch(COURT_CODE) {
        case COURT_SEASON_CODES.NBA_BASKETBALL:
        case COURT_SEASON_CODES.BASKETBALL:
            return (
                {
                    // Note: You will need to update in Coresponding Court.data.js file too
                    zoneCatByZoneArea: {
                        1: ["1", "2", "3", "14", "15", "16"],
                        2: ["4", "5", "12", "13"],
                        3: ["6", "7", "8", "9", "10", "11"],
                    },
                    sportBallImage: basketballImage,
                    court: BasketballGround,
                    courtBgImage: purcell_pavilion_arena,
                    commentaryPosition: (zone) => {
                      const topCommentaryForZones = ["1", "2", "3", "4", "5", "6", "7", "8"];
                      const topRightCommentaryForZones = ["9", "12", "14"];
                      // const bottomCommentaryForZones = [];

                      if (topCommentaryForZones.includes(zone)) {
                        return COMMENTARY_POSITION.PRIMARY;
                      } else if (topRightCommentaryForZones.includes(zone)) {
                        return COMMENTARY_POSITION.TERTIARY;
                      } else {
                        return COMMENTARY_POSITION.SECONDARY;
                      }
                    }
                }
            )
        
        case COURT_SEASON_CODES.FOOTBALL:
            return (
                {
                    // Note: You will need to update in Coresponding Court.data.js file too
                    zoneCatByZoneArea: {
                        1: ["1", "2", "3", "10", "11", "12"],
                        2: ["4", "5", "8", "9"],
                        3: ["6", "7"],
                    },
                    sportBallImage: footballImage,
                    court: FootballGround,
                    courtBgImage: stegeman_coliseum_arena,
                    commentaryPosition: (zone) => {
                      const topCommentaryForZones = ["1", "2", "3", "4", "5", "6"];
                      // const bottomCommentaryForZones = [];

                      if(topCommentaryForZones.includes(zone)) {
                        return COMMENTARY_POSITION.PRIMARY;
                      }else {
                        return COMMENTARY_POSITION.SECONDARY;
                      }
                    }
                }
            )

        default:
            return ({})
    }
}

export const getZoneCatByZoneArea = (zoneArea, zoneCatByZoneArea) => {
  let zoneCat = null;
  Object.entries(zoneCatByZoneArea).forEach(([key, value]) => {
    if (value.includes(zoneArea)) {
      zoneCat = key;
    }
  });

  return zoneCat;
};

export const zoneDataByZoneCat = (zoneCat, zoneCategories) => {
    if(!zoneCategories) return;
  
    switch(zoneCat) {
      case "1":
        return zoneCategories[0];
      case "2":
        return zoneCategories[1];
      case "3":
        return zoneCategories[2];
      default:
        return;
    }
  }

export const getZoneName = (zone, zoneCategories, court_code) => {
    const zoneCatByZoneArea = getSportCourtFields({ COURT_SEASON_CODES, COURT_CODE: court_code })?.zoneCatByZoneArea;
    if(!zoneCatByZoneArea) return;

    let zoneCat = getZoneCatByZoneArea(zone, zoneCatByZoneArea);
    let zoneData = zoneDataByZoneCat(zoneCat, zoneCategories);
    const indexInZoneCatByZoneName = zoneCatByZoneArea[zoneCat]?.indexOf(zone);
    const { zoneName } = zoneData?.zones[indexInZoneCatByZoneName] || {}

    return zoneName;    
}
